/* ============================================================
   FILTERS.JS — Filtres par tag + tri client-side (page collection)
   ============================================================ */
(function () {
  'use strict';

  const grid = document.querySelector('[data-product-grid]');
  if (!grid) return;

  const filterButtons = document.querySelectorAll('[data-filter]');
  const sortSelect = document.querySelector('[data-sort]');

  const getItems = () => Array.from(grid.querySelectorAll('[data-product-item]'));

  /* ---------- FILTRES ---------- */
  const applyFilter = (tag) => {
    const items = getItems();
    items.forEach((item) => {
      if (tag === 'all') {
        item.style.display = '';
        return;
      }
      const tags = (item.dataset.tags || '').split(',').map(t => t.trim());
      const match = tags.some(t => t === tag);
      item.style.display = match ? '' : 'none';
    });
  };

  filterButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      filterButtons.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      applyFilter(btn.dataset.filter);
    });
  });

  /* ---------- TRI ---------- */
  const parsePrice = (item) => {
    const priceEl = item.querySelector('.product-card__price');
    if (!priceEl) return 0;
    const txt = priceEl.textContent.replace(/[^\d,.\-]/g, '').replace(',', '.');
    return parseFloat(txt) || 0;
  };
  const parseTitle = (item) => {
    const t = item.querySelector('.product-card__title');
    return t ? t.textContent.trim().toLowerCase() : '';
  };

  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const value = sortSelect.value;
      const items = getItems();

      items.sort((a, b) => {
        switch (value) {
          case 'price-ascending': return parsePrice(a) - parsePrice(b);
          case 'price-descending': return parsePrice(b) - parsePrice(a);
          case 'title-ascending': return parseTitle(a).localeCompare(parseTitle(b));
          default: return 0;
        }
      });

      items.forEach(item => grid.appendChild(item));
    });
  }
})();
